import React, { Component } from 'react'
import DateTime from 'react-datetime'
import { Row, Col, Card, CardGroup, Button, Table, Image, Container } from 'react-bootstrap'
import BreadcrumbHeading from '../../breadcrumbs/BreadcrumbHeading'
import BarChart from '../../charts/BarChart'
import ManageQuestionModal from './ManageQuestionModal'
import NotifyExamStudentsModal from './NotifyExamStudentsModal'

import '../../../../react-datetime.css'
import './_managequestionpaper.scss';
import { withRouter } from "react-router-dom";

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import moment from 'moment';
// import { useReactToPrint } from "react-to-print";
import { withApollo } from "react-apollo";

// Base URL for the exam-paper PDF generation endpoints.
// Point this at the local backend (port 3008, matching src/index.js GraphQL) to
// test locally; swap back to the cloud URL for staging/prod.
const PAPER_API_BASE = "https://rizee-college-backend-755214126997.us-south1.run.app";
// const PAPER_API_BASE = "http://localhost:3008"; // local backend for testing

const EDIT_EXAM_SHEDULE = gql`
  mutation(
    $exam_paper_id: ID
    $start_time: String!
    $end_time: String!
    ) {
        updateExamTime(
            exam_paper_id:$exam_paper_id,
            start_time:$start_time,
            end_time:$end_time
     )
  }
`;

class QuestionPaperResultSection extends Component {
    constructor(props) {
        super(props)
        console.log("QuestionPaperResultSectionprops.getExams", props.getExams);
        let someData = "";
        if (props.getExams[0] != undefined) {
            someData = moment.unix(props.getExams[0].start_time).format("DD-MM-YYYY @ LT");
        }
        else {
            someData = "";
        }

        let someData1 = "";
        if (props.getExams[0] != undefined) {
            someData1 = moment.unix(props.getExams[0].end_time).format("DD-MM-YYYY @ LT");
        }
        else {
            someData1 = "";
        }

        let result_graph = "";
        if (props.getExams[0] != undefined) {
            result_graph = props.getExams[0].result_graph;
        }
        else {
            result_graph = "";
        }


        this.state = {
            currentStep: 1,
            start_time: someData,
            end_time: someData1,
            startdate: "",
            enddate: "",
            breadcrumbsData: {
                Title: "Question Papers Result"
            },
            modalShow: false,
            modalShowTwo: false,
            notifyShow: false,
            formValid: false,
            submitError: "",
            result_graph: result_graph,
            formErrors: {
                startdate: "",
                enddate: ""
            },
            startdateValid: false,
            enddateValid: false,
            keyData: []
        }
    }

    componentDidMount() {

        const keygenartor = async () => {

            const result = await this.props.client.query({
                query: gql` 
               query(
                $exam_paper_id: Int,
                   ) {
                    getExamkey(exam_paper_id: $exam_paper_id) {
                      answer
                   }
               }
           `,
                variables: {
                    exam_paper_id: parseInt(this.props.getExams[0].id),
                },
                fetchPolicy: 'network-only'
            });

            if (result.data.getExamkey != undefined) {

                let data = [];
                result.data.getExamkey.map((item, index) => {
                    data.push({ sno: index + 1, answer: item.answer, })
                })

                this.setState({ keyData: data });
                console.log("daaaa", data);

            }
        }

        keygenartor()


    }
    handleFormSubmit = e => {
        e.preventDefault();
        console.log("Form submitted");
        console.log("Cookies2", Cookies.get("username"));
        console.log("institutionid2", Cookies.get("institutionid"));

        if (this.state.formValid) {

            this.editexamshedule(
                this.props.getExams[0].id,
                this.state.startdate,
                this.state.enddate
            ).catch(error => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map(x => x.message)
                });
                console.error("ERR =>", error.graphQLErrors.map(x => x.message));
            });
        } else {
            this.setState({ submitError: "Please fill all the values to proceed" });
        }
    };
    editexamshedule = async (
        exam_paper_id,
        start_time,
        end_time

    ) => {
        await this.props.editexamshedule({
            variables: {
                exam_paper_id,
                start_time,
                end_time

            },
            update: (store, { data }) => {
                if (data.updateExamTime) {
                    let timestamp = moment(this.state.startdate, "MMM DD YYYY hh:mm:ss").unix();
                    let start_time = moment.unix(timestamp).format("DD-MM-YYYY @ LT");

                    let etimestamp = moment(this.state.enddate, "MMM DD YYYY hh:mm:ss").unix();
                    let end_time = moment.unix(etimestamp).format("DD-MM-YYYY @ LT");
                    this.setState({
                        start_time: start_time,
                        end_time: end_time,
                        currentStep: 2,
                        startdate: "",
                        enddate: "",
                        formValid: false,
                        submitError: "",
                        formErrors: {
                            startdate: "",
                            enddate: ""
                        },
                        startdateValid: false,
                        enddateValid: false
                    });

                    setTimeout(() => { this.SetpageLoad1() }, 1500);
                }
            }
        });
    };
    SetpageLoad1 = () => {
        console.log("setTimeout");
        this.setState({ currentStep: 1, modalShow: false });
    }
    datefunction = (moment, name) => {
        let date = String(moment._d);
        var res = date.substr(4, 20);
        this.setState({ startdate: res }, () => this.validateField("startdate", "1"));
    }
    datefunctionend = (moment, name) => {
        let date = String(moment._d);
        var res = date.substr(4, 20);
        this.setState({ enddate: res }, () => this.validateField("enddate", "1"));
    }
    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let startdateValid = this.state.startdateValid;
        let enddateValid = this.state.enddateValid;


        switch (fieldName) {
            case "startdate":
                if (value.length == "") {
                    startdateValid = false;
                    fieldValidationErrors.startdate = "Start Date Cannot Be Empty";
                } else {
                    startdateValid = true;
                    fieldValidationErrors.startdate = "";
                }

                break;

            case "enddate":
                if (value.length == "") {
                    enddateValid = false;
                    fieldValidationErrors.enddate = "End Date Cannot Be Empty";
                } else {
                    enddateValid = true;
                    fieldValidationErrors.enddate = "";
                }

                break;
            default:
                break;
        }
        this.setState(
            {
                formErrors: fieldValidationErrors,
                startdateValid: startdateValid,
                enddateValid: enddateValid,


            },
            this.validateForm
        );
    }
    validateForm() {
        this.setState({
            formValid: this.state.startdateValid && this.state.enddateValid
        });
        if (this.state.formValid) {
            this.setState({ submitError: "" });
        }
    }
    // Branch/section filter shared with the Student Results table below (ManageStudentResult's
    // own filter selection, lifted up by the page). Same predicate as that table's applyFilter
    // — both when set: match both; either one set: OR match — so the summary cards, chart and
    // table always agree on what's in scope, instead of the summary always showing everyone.
    getFilteredStudentResults() {
        const all = this.props.getExams[0].student_results || [];
        const branch = this.props.filterBranch;
        const section = this.props.filterSection;
        if (branch != "" && section != "") {
            return all.filter((a) => a.branch_id == branch && a.section_id == section);
        } else if (branch != "" || section != "") {
            return all.filter((a) => a.branch_id == branch || a.section_id == section);
        }
        return all;
    }
    resultFunction() {
        let all = this.getFilteredStudentResults();
        let getData = all.filter((a) => a.attempted_exam == true);
        let returnData = getData.length + "/" + all.length;
        return returnData;
    }
    resultPercentageFunction() {
        let all = this.getFilteredStudentResults();
        let getData = all.filter((a) => a.attempted_exam == true);
        let returnData = (getData.length) / (all.length) * 100;
        let returnData1 = Math.round(returnData) + "%"
        if (!isNaN(returnData)) {
            return returnData1;
        }
        else {
            return "";
        }

    }
    // Score-distribution bars, filtered. Recomputes the same 10 accuracy bands
    // (1-10..91-100) and the same percentage-of-total formula as the backend's
    // ResultsGraph.percentage resolver, but scoped to the filtered cohort — the backend
    // value is one fixed number for the whole exam paper, so a client recompute is the only
    // way the chart can react to the branch/section filter. Unfiltered (both blank) returns
    // the server value untouched, so default behavior is byte-for-byte the same as before.
    getFilteredResultGraph() {
        const branch = this.props.filterBranch;
        const section = this.props.filterSection;
        if ((branch == "" || branch == null) && (section == "" || section == null)) {
            return this.state.result_graph;
        }
        const all = this.getFilteredStudentResults();
        const total = all.length;
        const bands = [
            "1-10", "11-20", "21-30", "31-40", "41-50",
            "51-60", "61-70", "71-80", "81-90", "91-100",
        ];
        return bands.map((limit) => {
            const [lowStr, highStr] = limit.split("-");
            const low = parseInt(lowStr), high = parseInt(highStr);
            const count = all.filter((s) => {
                if (s.attempted_exam != true) return false;
                const acc = parseFloat(s.accuracy);
                return acc >= low && acc < high;
            }).length;
            const percentage = total == 0 ? 0 : Math.round((count / total) * 100);
            return { limit, percentage };
        });
    }
    editQuestionPaper() {
        console.log("editQuestionPaper", this.props);
        let examsData = this.props.globals.exams.find((a) => a.id == this.props.getExams[0].exam_type);
        let examsubjectData = examsData.exam_subjects;
        let subjects = [];
        for (let i = 0; i <= examsubjectData.length; i++) {
            let idata = examsubjectData[i];
            //console.log("idata", idata);
            if (idata != undefined) {
                let subjectData = this.props.globals.subjects.find((a) => a.id == idata.subject_id);
                console.log("massssssssssss", subjectData);
                let chapters = subjectData.chapters.map((item) => {
                    const topic = item.topics.map((topicData) => {
                        return { ...topicData, checked: false }
                    })
                    return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [] }
                })
                let newObject = {
                    id: subjectData.id,
                    subject: subjectData.subject,
                    chapters: chapters,
                    checked: false,
                    subjectactive: "d-flex justify-content-between align-items-center"
                }
                subjects.push(newObject);
            }

        }
        console.log("subjects", subjects);

        let subtype = "";
        if (this.props.getExams[0].sub_exam_type == "1") {
            subtype = { value: "1", label: "MAINS" }
        }
        else {
            subtype = { value: "1", label: "ADVANCE" }
        }

        let tcq = this.props.getExams[0].total_question_count;
        let totalExamCount3 = "";

        if (this.props.getExams[0].exam_type == "3" || this.props.getExams[0].exam_type == "6" || this.props.getExams[0].exam_type == "7" || this.props.getExams[0].exam_type == "8") {

            let eduration = this.props.globals.exams.find((a) => a.id == this.props.getExams[0].exam_type);
            console.log("eduration", eduration);

            if (eduration != undefined) {
                totalExamCount3 = parseFloat(eduration.avg_question_time) * parseFloat(tcq);
            }
        }

        this.props.history.push({
            pathname: "/questions/create-question-paper/own-question-paper/questionsPreview",
            state: {
                subjects: subjects,
                examtypema: this.props.getExams[0].sub_exam_type,
                examtypemavalue: subtype,
                class: this.props.getExams[0].class_id,
                classvalue: {
                    value: this.props.getExams[0].class_id,
                    label: this.props.getExams[0].class
                },
                examtype: this.props.getExams[0].exam_type,
                examtypevalue: {
                    value: this.props.getExams[0].exam_type,
                    label: this.props.getExams[0].exam_name
                },
                exam_paper_id: this.props.getExams[0].id,
                exam_questions: this.props.getExams[0].exam_questions,
                // breadCrumbsData: this.props.history.getExams
                type: "edit",
                branch: this.props.getExams[0].branch,
                section: this.props.getExams[0].section,
                tcq: tcq,
                totalExamCount3: totalExamCount3
            }
        });
    }

    keyDownlaod = async (paper_id) => {


        // setTimeout(() => {
        //     this.setState({ PDFGenerator: false });
        // }, 5000);


    }

    // Print/download the Answer Key using the same printable-HTML approach as the
    // Fee "View Report" (window.open + print) — gives a proper logo + name + address
    // header and avoids the html2canvas logo/CORS/layout issues.
    printAnswerKey = () => {
        const key = this.state.keyData || [];
        if (key.length === 0) {
            window.alert("No answer key found to download.");
            return;
        }

        const org = this.props.getOrganisationProfile || {};
        const orgName = org.organisation_name || Cookies.get("institutename") || "";
        const logoFile = org.logo || "";
        const logoUrl = logoFile ? `https://support.rizee.in/files/${logoFile}` : (Cookies.get("url") || Cookies.get("institute_logo") || "");
        const address = Cookies.get("address") || Cookies.get("institute_address") || "";
        const examName = this.props.getExams[0] != undefined ? this.props.getExams[0].name : "";
        const examDate = this.state.start_time || "";

        // Answer key grid: 10 question/answer pairs per row.
        let bodyRows = "";
        for (let i = 0; i < key.length; i += 10) {
            let cells = "";
            for (let j = i; j < i + 10 && j < key.length; j++) {
                cells += `<td class="qn">${key[j].sno}</td><td class="an">${key[j].answer}</td>`;
            }
            bodyRows += `<tr>${cells}</tr>`;
        }
        const headCols = Array.from({ length: 10 }).map(() => `<th>Q</th><th>A</th>`).join("");

        const win = window.open("", "_blank", "width=1100,height=750");
        win.document.write(`<html><head><title>Answer Key</title><style>
            *{margin:0;padding:0;box-sizing:border-box}
            body{font-family:Arial,sans-serif;padding:24px;color:#111;font-size:12px}
            .report-wrapper{width:1000px;margin:0 auto}
            .report-header{position:relative;text-align:center;border-bottom:2px solid #333;padding-bottom:14px;margin-bottom:14px;min-height:64px;display:flex;flex-direction:column;justify-content:center}
            .report-header img{position:absolute;left:0;top:50%;transform:translateY(-50%);width:auto;height:60px;object-fit:contain}
            .org-name{font-size:26px;font-weight:800;color:#13287a;margin-bottom:4px;letter-spacing:.3px}
            .org-addr{font-size:12px;color:#b1700c;line-height:1.5;max-width:640px;margin:0 auto}
            .report-sub{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px}
            .report-sub .title{font-size:15px;font-weight:700}
            .report-sub .meta{font-size:12px;color:#555}
            table{width:100%;border-collapse:collapse;font-size:12px}
            th{background:#f3f4f6;padding:7px 6px;text-align:center;font-size:11px;border:1px solid #d1d5db}
            td{padding:7px 6px;border:1px solid #e5e7eb;text-align:center}
            td.qn{font-weight:700;background:#fafafa}
            tr:nth-child(even) td{background:#fcfcfc}
            tr:nth-child(even) td.qn{background:#f3f4f6}
            @media print{body{padding:6px}@page{size:landscape;margin:6mm}}
        </style></head><body>
            <div class="report-wrapper">
                <div class="report-header">
                    ${logoUrl ? `<img src="${logoUrl}" />` : ""}
                    <div class="org-name">${orgName}</div>
                    <div class="org-addr">${address}</div>
                </div>
                <div class="report-sub">
                    <div class="title">Answer Key</div>
                    <div class="meta">Exam Name: <strong>${examName}</strong>${examDate ? ` &nbsp;|&nbsp; Date: <strong>${examDate}</strong>` : ""}</div>
                </div>
                <table>
                    <thead><tr>${headCols}</tr></thead>
                    <tbody>${bodyRows}</tbody>
                </table>
            </div>
            <script>
                ${logoUrl ? `var img=document.querySelector('img');if(img&&!img.complete){img.onload=function(){window.print();window.close();};img.onerror=function(){window.print();window.close()};}else{window.print();window.close();}` : `window.print();window.close();`}
            <\/script>
        </body></html>`);
        win.document.close();
        win.focus();
    }


    render() {
        console.log(this.props.getExams, "sdfiuregoyiwr")
        // Once the exam start time has passed, rescheduling is no longer allowed.
        const examStarted = this.props.getExams[0] != undefined && moment().unix() >= parseInt(this.props.getExams[0].start_time);
        return (
            <section className="question_paper_results mb-4">
                <Row className="align-items-center mt-3">
                    <Col xl={9} lg={9} md={8} sm={8} xs={7}>
                        <BreadcrumbHeading breadcrumbs={this.state.breadcrumbsData} />
                    </Col>
                    <Col xl={3} lg={3} md={4} sm={4} xs={5} className="text-right">
                        <Button
                            className="mr-3"
                            size="sm"
                            style={{ background: "#7c3aed", borderColor: "#7c3aed", color: "#fff", fontWeight: 600 }}
                            onClick={() => this.setState({ notifyShow: true })}
                        >
                            <i className="fas fa-bell mr-1" /> Send Notification
                        </Button>
                        <Button
                            variant="link"
                            className="text-theme p-0"
                            style={{ fontWeight: 700, textDecoration: "none" }}
                            onClick={() => this.props.history.push("/questions/manage-question-paper")}
                        >
                            <i className="fal fa-arrow-left mr-2" />Back
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <Card as={Card.Body} className="border-0 shadow-sm manage_questionPaper_results"
                            style={{ background: "#ffffff" }}>
                            <CardGroup className="mb-4">
                                <Card bg="white" text="dark">
                                    <Card.Body>
                                        <Card.Text>Exam Type</Card.Text>
                                        <Card.Title>{this.props.getExams[0] != undefined ? this.props.getExams[0].exam_name : ""}</Card.Title>
                                    </Card.Body>
                                </Card>
                                <Card bg="white" text="dark">
                                    <Card.Body>
                                        <Card.Text>Class</Card.Text>
                                        <Card.Title>{this.props.getExams[0] != undefined ? this.props.getExams[0].class : ""}</Card.Title>
                                    </Card.Body>
                                </Card>
                                <Card bg="white" text="dark">
                                    <Card.Body>
                                        <Card.Text>Scheduled On</Card.Text>
                                        <Card.Title>{this.state.start_time}</Card.Title>
                                    </Card.Body>
                                </Card>
                                <Card bg="white" text="dark">
                                    <Card.Body>
                                        <Card.Text>End Time</Card.Text>
                                        <Card.Title>{this.state.end_time}</Card.Title>
                                    </Card.Body>
                                </Card>
                                <Card bg="white" text="dark">
                                    <Card.Body>
                                        <Card.Text>Results</Card.Text>
                                        {/* <Card.Title>50/60 <span className="text-primary">80%</span> </Card.Title> */}
                                        <Card.Title>{this.resultFunction()} <span className="text-primary">{this.resultPercentageFunction()}</span> </Card.Title>
                                    </Card.Body>
                                </Card>
                                <Card bg="white" text="dark">
                                    <Card.Body>
                                        <Card.Text>Status</Card.Text>
                                        <Card.Title>{this.props.location.state != undefined ? this.props.location.state.is_completed : ""}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </CardGroup>
                            <Row>
                                <Col xl={8} lg={12} md={12} sm={12} xs={12}>
                                    <Card as={Card.Body} className="p-3 shadow-sm mb-3">
                                        <div className="d-md-flex justify-content-between align-items-center mb-3">
                                            <h6>Percentage wise Result</h6>
                                            <div className="date-block d-flex align-items-center">
                                                {this.state.start_time}
                                                {/* <span className="mr-2">Scheduled Date: </span><DateTime dateFormat="DD-MM-YYYY" inputProps={{ Placeholder: '12-05-2019' }} timeFormat={false} /> */}
                                            </div>
                                        </div>
                                        <BarChart
                                            result_graph={this.getFilteredResultGraph()} />
                                    </Card>
                                </Col>
                                <Col xl={4} lg={12} md={12} sm={12} xs={12}>
                                    <Card as={Card.Body} className="p-3 shadow-sm mb-3">
                                        <h6 className="mb-3">Reschedule Details</h6>
                                        <Card style={{ height: 100 }}>
                                            <Card.Header className="d-flex justify-content-between text-white" style={{ background: "#dee2e6" }}>
                                                <h6 className="title mb-0 text-dark">Date</h6>
                                                <h6 className="title mb-0 text-dark">Status</h6>
                                            </Card.Header>
                                            <Card.Body className="d-flex justify-content-between">
                                                <p>{this.state.start_time}</p>
                                                <p>{this.props.location.state != undefined ? this.props.location.state.is_completed : ""}</p>
                                            </Card.Body>
                                        </Card>
                                    </Card>
                                    <div className="text-center">
                                        {/* {moment().unix() >= this.props.getExams[0].start_time ? ("") : ( */}
                                        <React.Fragment>
                                            <div className="d-flex ml-auto text-white">
                                                <Button className="btn my-2" block style={{ background: "#f59e0b", borderColor: "#f59e0b", color: "#fff" }} onClick={() => this.editQuestionPaper()}>Edit Question Paper</Button>
                                                <Button
                                                    className="btn my-2 ml-2"
                                                    block
                                                    disabled={examStarted}
                                                    title={examStarted ? "Exam has already started — rescheduling is not allowed" : ""}
                                                    style={{ background: "#6366f1", borderColor: "#6366f1", color: "#fff", opacity: examStarted ? 0.55 : 1, cursor: examStarted ? "not-allowed" : "pointer" }}
                                                    onClick={() => { if (!examStarted) this.setState({ modalShow: true }); }}
                                                >Reschedule online question paper</Button>
                                            </div>
                                        </React.Fragment>
                                        {/* )} */}
                                        <div className="d-flex ml-auto">
                                            <a className="btn my-2" block style={{ background: "#3b82f6", borderColor: "#3b82f6", color: "#fff" }} href={`${PAPER_API_BASE}/generate-exam-paper?exam=${this.props.getExams[0].id}`} target="_blank">Preview &amp; Download question paper</a>
                                            <Button className="btn my-2 ml-2" block style={{ background: "#10b981", borderColor: "#10b981", color: "#fff" }} onClick={() => this.printAnswerKey()}>Download key</Button>
                                        </div>
                                        {/* <Button className="btn btn-info my-2" block >Paper Download with Key</Button> */}
                                        {/*<div className="d-flex ml-auto">
                                            <a className="btn btn-primary my-2 " style={{ width: '70%', alignContent: "center" }} block href={`https://support.rizee.in/pdf/generate_key.php?exam=${this.props.getExams[0].id}`} target="_blank">Paper Download with Key</a>
                                            <a className="btn btn-primary my-2 ml-2" block href={`https://support.rizee.in/pdf/generate_expkey.php?exam=${this.props.getExams[0].id}`} target="_blank"   >Paper Download with Explanation &amp; Key</a>
                                        </div>*/}
                                        <div className="d-flex ml-auto">
                                            <a className="btn my-2 " style={{ width: '70%', alignContent: "center", background: "#0891b2", borderColor: "#0891b2", color: "#fff" }} block href={`${PAPER_API_BASE}/generate-exam-paper-with-key?exam=${this.props.getExams[0].id}`} target="_blank">Paper Download with Key</a>
                                            <a className="btn my-2 ml-2" style={{ background: "#8b5cf6", borderColor: "#8b5cf6", color: "#fff" }} block href={`${PAPER_API_BASE}/generate-exam-paper-with-key-exp?exam=${this.props.getExams[0].id}`} target="_blank">Paper Download with Explanation &amp; Key</a>
                                        </div>
                                        {/* <Button className="btn btn-secondary my-2" block >Paper Download with Explanation &amp; Key</Button> */}
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <ManageQuestionModal
                    ParenthandleFormSubmit={this.handleFormSubmit}
                    datefunction={this.datefunction}
                    datefunctionend={this.datefunctionend}
                    stateData={this.state}
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                />
                <NotifyExamStudentsModal
                    show={this.state.notifyShow}
                    onHide={() => this.setState({ notifyShow: false })}
                    examId={this.props.getExams[0] != undefined ? this.props.getExams[0].id : 0}
                    examName={this.props.getExams[0] != undefined ? this.props.getExams[0].exam_name : ""}
                    examType={this.props.getExams[0] != undefined ? this.props.getExams[0].exam_type : null}
                    students={this.props.getExams[0] != undefined ? (this.props.getExams[0].student_results || []) : []}
                />
            </section>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(EDIT_EXAM_SHEDULE, {
        name: "editexamshedule"
    }))(QuestionPaperResultSection)));
